<div *ngIf="!inView"
     class="st-assignment-item-content-container"></div>
<div *ngIf="inView"
     class="st-assignment-item-border-left"
     leftBorder
     [record]="data">
</div>
<ng-template [ngIf]="showFullCard"
             [ngIfElse]="mobileCard">
    <div *ngIf="inView"
         class="st-assignment-item-content-container"
         [class.st-assignment-item-content-container__mouse-entered]="mouseEntered"
         (mouseenter)="onMouseEnter()"
         (mouseleave)="onMouseLeave()">
        <div class="st-assignment-item-content-container__static">
            <div class="st-assignment-item-content-container-main">
                <div class="st-assignment-item-content-container-main-top-row">
                    <st-text-area-overlay class="st-assignment-item-content-container-main-top-row__slug"
                                          minRows="1"
                                          minHeight="1rem"
                                          [textToHighlight]="searchString"
                                          maxLength="50"
                                          disableNewLine
                                          [value]="data?.assignmentSlug"
                                          (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentSlug)"
                                          panelClass="st-assignment-item-content-container-main__slug"
                                          [disabled]="cardDisabled"
                                          [placeholder]="languageSettings.PSTWebSlugPlaceholder"></st-text-area-overlay>
                    <span class="st-assignment-item-content-container-main__time-updated">{{timeUpdatedLabel}}</span>
                    <span class="st-assignment-item-content-container-main__updated-by">{{updatedBy}}</span>
                </div>
                <st-text-area-overlay class="st-assignment-item-content-container-main__summary"
                                      [value]="data?.coverage"
                                      minRows="4"
                                      minHeight="4rem"
                                      [textToHighlight]="searchString"
                                      panelClass="st-assignment-item-content-container-main__summary"
                                      (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentCoverage)"
                                      [disabled]="cardDisabled"
                                      [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentCoverage]?.DefaultCaption"></st-text-area-overlay>
                <tags-autocomplete [value]="data?.tags"
                                   (changed)="updateAssignment($event, pstFieldNames.PSTTopicTag)"
                                   maxItemsToShow="5"
                                   [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicTag]?.Required"
                                   [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTTopicTag]"
                                   [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicTag]?.DefaultCaption">
                </tags-autocomplete>
            </div>
            <div class="st-assignment-item-content-container-assigns">
                <desk class="st-assignment-item-content-container-assigns__desk"
                      [value]="data?.department"
                      [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentPublishingDesk]?.Required"
                      (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentPublishingDesk)"
                      [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentPublishingDesk]?.DefaultCaption"
                      [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentPublishingDesk]?.DefaultCaption"
                      [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentPublishingDesk]"
                      [itemList]="globalTablesService.getListItemsForDesk(data.type)">
                </desk>
                <staff-id-list [value]="data?.storyOwner"
                               (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentOwner)"
                               [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentOwner]?.DefaultCaption"
                               [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentOwner]"
                               class="st-assignment-item-content-container-assigns__owners"></staff-id-list>
                <div class="st-assignment-item-content-container-assigns__assignments">
                    <assignment-type *ngIf="data"
                                     showLabel
                                     [record]="data"
                                     [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentCoverageType]"
                                     [value]="data?.coverageType"
                                     (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentCoverageType)">
                    </assignment-type>
                </div>
            </div>
            <div class="st-assignment-item-content-container-meta">
                <date-time-picker class="st-assignment-item-content-container-meta__date-picker"
                                  [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentFileDate]"
                                  asCustomField
                                  *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentFileDate]?.Validation?.toUpperCase() == FieldDefValidations.TIME; else datePicker"
                                  [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentFileDate]?.Required"
                                  [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentFileDate]?.DefaultCaption"
                                  (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentFileDate)"
                                  [value]="getDateTimeValue(pstFieldNames.PSTAssignmentFileDate)">
                </date-time-picker>
                <ng-template #datePicker>
                    <date-picker class="st-assignment-item-content-container-meta__date-picker"
                                 [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentFileDate]?.Required"
                                 [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentFileDate]?.DefaultCaption"
                                 (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentFileDate)"
                                 [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentFileDate]"
                                 [value]="getDateTimeValue(pstFieldNames.PSTAssignmentFileDate)"></date-picker>
                </ng-template>
                <status class="st-assignment-item-content-container-meta__status"
                        [value]="data.status"
                        [disabled]="cardDisabled || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentStatus]"
                        [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentStatus]?.Required"
                        (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentStatus)"
                        [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentStatus]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTAssignmentStatus)">
                </status>
            </div>
            <div class="st-assignment-item-content-container-actions">
                <div *ngIf="!isPublication">
                    <button class="st-assignment-item-content-container-actions__external"
                            mat-icon-button
                            #trigger="cdkOverlayOrigin"
                            cdkOverlayOrigin
                            [disabled]="cardDisabled"
                            (click)="isPanelOpen = true">
                        <mat-icon>more_horiz</mat-icon>
                    </button>

                    <ng-template #externalActions>
                        <ng-template cdkConnectedOverlay
                                     [cdkConnectedOverlayOrigin]="trigger"
                                     (overlayOutsideClick)="isPanelOpen = false"
                                     [cdkConnectedOverlayOpen]="isPanelOpen">
                            <external-actions-overlay [data]="data"
                                                      [editable]="assignmentEditable"
                                                      [inFullScreen]="inFullscreenMode"
                                                      [isPanelOpen]="isPanelOpen"
                                                      [onDelete]="assignmentDeleted"
                                                      [onObjectOpen]="assignmentOpened"
                                                      (onActionClick)="isPanelOpen = false">
                            </external-actions-overlay>
                        </ng-template>
                    </ng-template>
                </div>

                <button mat-icon-button
                        *ngIf="isPublication"
                        [disabled]="cardDisabled"
                        class="st-assignment-item-content-container-actions__delete"
                        (click)="deletePublication($event)">
                    <mat-icon>delete_outline</mat-icon>
                </button>

                <ng-container *ngIf="inFullscreenMode; else defaultFullscreenIcon">
                    <button class="st-assignment-item-content-container-actions__fullscreen"
                            (click)="assignmentOpened.emit()"
                            [disabled]="isReadOnly"
                            mat-icon-button>
                        <mat-icon>arrow_forward</mat-icon>
                    </button>
                </ng-container>
                <ng-template #defaultFullscreenIcon>
                    <button class="st-assignment-item-content-container-actions__fullscreen"
                            (click)="assignmentOpened.emit()"
                            [disabled]="isReadOnly"
                            [matTooltip]="languageSettings.PSTWebOpenFullScreenText"
                            mat-icon-button>
                        <mat-icon>fullscreen</mat-icon>
                    </button>
                </ng-template>
                <button class="st-assignment-item-content-container-actions__approve"
                        *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.AssignmentProp"
                        (click)="updateAssignment(!data.pstApproved, pstFieldNames.PSTApproved)"
                        [disabled]="cardDisabled"
                        [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.DefaultCaption"
                        [class.st-assignment-item-content-container-actions__approve--active]="data.pstApproved"
                        mat-icon-button>
                    <mat-icon>done</mat-icon>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #mobileCard>
    <div *ngIf="inView"
         class="st-assignment-item-content-container__mobile">
        <div class="st-assignment-item-content-container__mobile--top-row">
            <div class="st-assignment-item-content-container__mobile--status">
                {{data.status || globalTablesService.FieldDefsDict[pstFieldNames.PSTAssignmentStatus]?.DefaultCaption}}
            </div>
        </div>
        <div class="st-assignment-item-content-container__mobile--slug">
            {{data.assignmentSlug}}
        </div>

        <div class="st-assignment-item-content-container__mobile--desk">
            <mat-icon class="st-assignment-item-content-container__mobile--owner__icon">
                business
            </mat-icon>
            <span
                  class="st-assignment-item-content-container__mobile--owner__text">{{getItemString(pstFieldNames.PSTAssignmentPublishingDesk)}}</span>
        </div>

        <div class="st-assignment-item-content-container__mobile--owner">
            <mat-icon class="st-assignment-item-content-container__mobile--owner__icon">
                people
            </mat-icon>
            <span
                  class="st-assignment-item-content-container__mobile--owner__text">{{getItemString(pstFieldNames.PSTAssignmentOwner)}}</span>
        </div>

        <assignment-type *ngIf="data"
                         showLabel
                         mediumIcon
                         [disabled]="cardDisabled"
                         [record]="data"
                         [value]="data?.coverageType"
                         (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentCoverageType)">
        </assignment-type>
    </div>
</ng-template>
